export default __webpack_public_path__ + "resources/icons/n322-ba12.png";